import { render, staticRenderFns } from "./hospitalRoute.vue?vue&type=template&id=3dcae5b6&scoped=true"
var script = {}
import style0 from "./hospitalRoute.vue?vue&type=style&index=0&id=3dcae5b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcae5b6",
  null
  
)

export default component.exports